import { Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { of } from 'rxjs';
import { UserDataService } from '../../../shared/services/user-data/user-data.service';
import {
  ES_POSTAL_CODE_REGEXP,
  VALIDATORS_LENGTH,
} from '../../../shared/utils/constants';
import { MortgageService } from '../../services/mortgage/mortgage.service';

@Component({
  selector: 'app-housing-data-form',
  templateUrl: './housing-data-form.component.html',
  styleUrls: ['./housing-data-form.component.scss'],
  standalone: false,
})
export class HousingDataFormComponent implements OnInit, OnDestroy {
  @Output() emitForm: EventEmitter<UntypedFormGroup> = new EventEmitter();

  public HTML_VALIDATORS = VALIDATORS_LENGTH;
  public housingDataForm: UntypedFormGroup;
  public minDate = new Date();
  public currentValue = '';

  public validatorsForm = {
    postCode: [Validators.pattern(ES_POSTAL_CODE_REGEXP)],
    squareMeters: [Validators.maxLength(VALIDATORS_LENGTH.maxLength.squareMeters)],
    signatureDate: [],
  };
  constructor(
    private formBuilder: UntypedFormBuilder,
    private _userDataService: UserDataService,
    private _mortgageService: MortgageService,
  ) {}

  ngOnInit() {
    this.createHousingDataForm();
    this.housingDataForm.patchValue(this._userDataService.getUserData().level2Data);
    this._userDataService.subscribeChanges().subscribe((change) => {
      if (change) {
        this.housingDataForm.patchValue(this._userDataService.getUserData().level2Data);
      }
    });
  }

  createHousingDataForm() {
    this.housingDataForm = this.formBuilder.group({
      postCode: ['', this.validatorsForm.postCode, this.validatePostalCode()],
      squareMeters: ['', this.validatorsForm.squareMeters],
      signatureDate: ['', this.validatorsForm.signatureDate],
    });
    // this.housingDataForm.controls.postCode.setAsyncValidators(this.validatePostalCode());
    this.emitForm.emit(this.housingDataForm);

    this.housingDataForm.controls.squareMeters.valueChanges.subscribe((value) => {
      let auxValue = value.replace(/[^0-9.]+/g, '');
      if (auxValue) {
        auxValue = parseFloat(auxValue).toString();
      }
      if (value !== auxValue) {
        this.housingDataForm.controls.squareMeters.setValue(auxValue);
      }
    });
  }

  resetValidator() {
    for (const campo in this.housingDataForm.controls) {
      this.housingDataForm.controls[campo].setValidators(this.validatorsForm[campo]);
      this.housingDataForm.controls[campo].updateValueAndValidity();
      this.housingDataForm.controls[campo].markAsTouched();
    }
  }

  setValidatorRequired() {
    for (const campo in this.housingDataForm.controls) {
      this.housingDataForm.controls[campo].validator
        ? this.housingDataForm.controls[campo].setValidators([
            this.housingDataForm.controls[campo].validator,
            Validators.required,
          ])
        : this.housingDataForm.controls[campo].setValidators([Validators.required]);
      this.housingDataForm.controls[campo].updateValueAndValidity();
      this.housingDataForm.controls[campo].markAsTouched();
    }
  }

  private validatePostalCode() {
    return ({ value }) => {
      if (
        value !== '' &&
        value.match(ES_POSTAL_CODE_REGEXP) &&
        this.currentValue !== value
      ) {
        return this._mortgageService.validatePostalCode(value);
      } else {
        this.currentValue = value;
        return of(null);
      }
    };
  }

  ngOnDestroy() {
    this.housingDataForm.controls.postCode.setAsyncValidators([]);
  }
}
